import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import FooterCta from '@/app/components/FooterCta';
import useAppStoreUrl from '@/app/hooks/useAppStoreUrl';

const IntegrationsFooterCta = () => {
  const linkHref = useAppStoreUrl();
  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'app store download',
      cta: 'download_oura_app',
      location: 'body',
      path: href,
    });
  };

  return (
    <FooterCta
      buttons={[
        {
          href: linkHref,
          label: 'integrations_footer_cta_link',
          onClick: handleLinkClick,
          target: '_blank',
          variant: 'secondary-dark',
        },
      ]}
      className="py-20"
      description="integrations_footer_cta_copy_2"
      image={{
        localizedAlt: 'integrations_footer_cta_img_alt',
        src: '/blue-sky/integrations/integrations-footer-cta.png?ar=4:3&fit=crop&crop=focalpoint&fp-x=0.4&fp-y=0.5fp-z=1',
      }}
      title="integrations_footer_cta_title"
      variant={{
        sm: 'two_column',
        lg: 'two_column',
      }}
    />
  );
};

export default IntegrationsFooterCta;
